import createGraphqlClient from "@/utils/apollo";

export const fragments = {
	ReportFormDetail: `
		fragment ReportFormDetail on Form {
			id
			name
			code
			enable
			can_update
			can_delete
			category_id
			employee {
				id
				name
			}
		}
	`,
	ReportFormSubmit: `
		fragment ReportFormSubmit on Form {
			id
			name
			code
			properties
			display_name
			attachs {
				id
				path
				file_name
				file_size
				extension
			}
			controls {
				id
				title
				control
				children
				attributes
				is_optional
				description {
					value
					enable
					position
				}
			}
			is_submited
			can_update
			can_delete
		}
	`,
	ReportFormConfig: `
		fragment ReportFormConfig on Form {
			id
			name
			code
			enable
			attachs {
				id
				path
				file_name
				file_size
				extension
			}
			can_update
			can_delete
			category_id
			employee {
				id
				name
			}
			controls {
				id
				title
				control
				children
				attributes
				is_optional
				enable
				description {
					value
					enable
					position
				}
			}
		}
	`,
	ReportFormListPagination: `
		fragment ReportFormListPagination on FormPagination {
			data {
				id
				name
				code
				enable
				updated_at
				can_update
				can_delete
				category_id
				employee {
					id
					name
				}
			}
			total
		}
    `
};

export default createGraphqlClient("cmagile");
